import React, { Component } from 'react'
import { compose } from 'redux'
import querystring from 'querystring'
import config from 'config'
import PropTypes from 'prop-types'
import scriptLoader from 'react-async-script-loader'
import { Collapse } from 'react-collapse'
import { Text } from '@cred/react-text'
import { collapsibleClick } from '@cred/react-analytics/events'
import { withSnowplowContexts } from '@cred/react-analytics/SnowplowContextManager'
import LendersList from 'components/lenders-list'
import { allLenders } from '../lenders-data'
import styles from './styles.scss'

class ShortenedRateTableApp extends Component {
  static propTypes = {
    isScriptLoaded: PropTypes.bool,
    isScriptLoadSucceed: PropTypes.bool,
    utms: PropTypes.shape({
      utm_source: PropTypes.string,
      utm_campaign: PropTypes.string,
      utm_medium: PropTypes.string,
      utm_content: PropTypes.string,
      credclid: PropTypes.string,
      renderId: PropTypes.string,
    }),
    trackSnowplowEvent: PropTypes.func,
    theme: PropTypes.string,
  }

  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
    }
  }

  render() {
    const lenders = this.loadLenders(),
      { theme } = this.props,
      { isOpen } = this.state,
      totalLender = lenders.length,
      iconClass = isOpen ? 'icon-chevron-up' : 'icon-chevron-down'

    return (
      <div>
        <LendersList
          lenders={lenders.slice(0, 3)}
          ctaUrl={this.getCtaUrl()}
          theme={theme}
          name="StudentLoanRefi"
          compareFn={ShortenedRateTableApp.compareLenders}
        />
        <div>
          <Collapse isOpened={isOpen}>
            <LendersList
              lenders={lenders.slice(3)}
              ctaUrl={this.getCtaUrl()}
              theme={theme}
              noBorder
              name="StudentLoanRefi"
              compareFn={ShortenedRateTableApp.compareLenders}
            />
          </Collapse>
          <div className={styles.viewMoreSection} onClick={this.toggleLenderList}>
            <Text className={`${styles.viewMore} align-center`}>
              { isOpen ? 'Hide additional lenders' : `View ${totalLender - 3} more lenders` }
              <span className={`cred-icon ${iconClass}`} />
            </Text>
          </div>
        </div>
      </div>
    )
  }

  /* Get rates from Rates Update library. */
  loadLenders() {
    const { isScriptLoaded, isScriptLoadSucceed } = this.props,
      lenders = [],
      filterFixed = {
        rateType: 'apr',
        vertical: 'refi',
        term: null,
        variable: false,
      },
      filterVariable = {
        rateType: 'apr',
        vertical: 'refi',
        term: null,
        variable: true,
      },
      options = {
        decimals: 2,
        append: '',
        prepend: '',
      }

    /* Get the rates after loading the ratesLibrary JS and do it only once. */
    if (isScriptLoaded && isScriptLoadSucceed) {
      allLenders.forEach(lender => {
        const minRateFixed = global.ratesLibrary.getRateValue(
            { lenderSlug: lender.rateSlug, name: 'min', ...filterFixed },
            options,
          ),
          maxRateFixed = global.ratesLibrary.getRateValue(
            { lenderSlug: lender.rateSlug, name: 'max', ...filterFixed },
            options,
          )

        let minRateVar,
          maxRateVar

        if (lender.rateSlug !== 'kheslc') {
          minRateVar = global.ratesLibrary.getRateValue(
            { lenderSlug: lender.rateSlug, name: 'min', ...filterVariable },
            options,
          )
          maxRateVar = global.ratesLibrary.getRateValue(
            { lenderSlug: lender.rateSlug, name: 'max', ...filterVariable },
            options,
          )
        }

        /* In case there is any problem searching for rates. */
        if (minRateFixed) {
          lenders.push(
            {
              minRateFixed,
              maxRateFixed,
              minRateVar,
              maxRateVar,
              ...lender,
            },
          )
        }
      })
    }

    return lenders.sort(ShortenedRateTableApp.compareLenders)
  }

  static compareLenders(a, b) {
    return parseFloat(a.minRateFixed) - parseFloat(b.minRateFixed)
  }

  toggleLenderList = () => {
    const { trackSnowplowEvent } = this.props,
      { isOpen } = this.state

    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))

    trackSnowplowEvent(collapsibleClick, {
      text: isOpen ? 'Hide additional lenders' : 'Show additional lenders',
      action: isOpen ? 'collapse' : 'expand',
    })
  }

  getCtaUrl() {
    // eslint-disable-next-line camelcase
    const { utms: { utm_source, utm_medium, utm_campaign, utm_content, credclid, renderId } } = this.props,
      params = {
        utm_source,
        utm_medium,
        utm_campaign,
        utm_content,
        credclid,
        renderId,
      }

    return `${config.credibleRoot}/refinance/prequal/signup?${querystring.encode(params)}`
  }
}

export { ShortenedRateTableApp }

export default compose(
  scriptLoader(config.ratesLibraryUrl),
  withSnowplowContexts,
)(ShortenedRateTableApp)
